import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({ name: 'developer-bar' })

export default class DeveloperBar extends Vue {
    @Prop({ default: () => () => {} }) readonly printStatus: Function;
    @Prop({ default: () => () => {} }) readonly clearStore: Function;
    @Prop({ default: () => () => {} }) readonly reshuffle: Function;

    private posX: number = 0; 
    private posY: number = 0; 

    private dragging: boolean = false;
    private offset: { x: number; y: number } = { x: 0, y: 0 };

    get barStyle() {
        return {
        left: this.posX + 'px',
        top: this.posY + 'px',
        position: 'fixed',
        zIndex: 9999
        };
    }

    startDrag(e) {
        this.dragging = true;
        this.offset = {
        x: e.clientX - this.posX,
        y: e.clientY - this.posY
        };
        document.addEventListener('mousemove', this.onDrag);
        document.addEventListener('mouseup', this.stopDrag);
    }

    onDrag(e) {
        if (!this.dragging) return;
        this.posX = e.clientX - this.offset.x;
        this.posY = e.clientY - this.offset.y;
    }

    stopDrag() {
        this.dragging = false;
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
    }

    handleResize() {
        this.posX = window.innerWidth - 160;
        this.posY = window.innerHeight - 130;
    }

    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }
    
    destroyed() {
        document.removeEventListener('mousemove', this.onDrag);
        document.removeEventListener('mouseup', this.stopDrag);
        window.removeEventListener('resize', this.handleResize);
    }
}